import { BreadCrumb } from "primereact/breadcrumb";
import { routes } from "../../../routes";
import { useEffect, useState } from "react";
import UserService from "../../../api/UserService";
import useAuth from "../../../hooks/useAuth";
import moment from "moment";
import { Chip } from "primereact/chip";
import { Tag } from "primereact/tag";

const Profil = () => {
  const items = [{ label: "Profil" }];
  const statistic = { icon: "pi pi-chart-bar", url: routes.dashboard.profil };
  const { auth } = useAuth();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [newPasswordConfirmationError, setNewPasswordConfirmationError] =
    useState("");
  const [isLoading, setLoading] = useState(false);
  console.log("====================================");
  console.log(auth);
  console.log("====================================");
  useEffect(() => {
    /*  UserService.get(userData?.auth?.user?.id).then((res) => {
      setLoading(false);
    });
    if (userData?.auth?.user?.fresh) {
      // setShowUpdatePasswordModal(true);
    } */
  }, []);
  return (
    <div className="p-4 w-full border-round">
      <div>
        <BreadCrumb model={items} home={statistic} />
      </div>
      <div className="profile-container bg-white my-3 py-4  px-4 card border-round">
        <div className="profile-wraper">
          <div className="profile-grid-section-container">
            <div className="profile-grid-section">
              <div className="profile-grid-item">
                <div className="profile-grid-item-title"> Nom</div>
                <div className="profile-grid-item-wraper">
                  <div className="profile-grid-item-icon">
                    <span className="pi pi-user"></span>
                  </div>
                  <div className="profile-grid-item-content">
                    {auth?.user?.lastname}
                  </div>
                </div>
              </div>
              <div className="profile-grid-item">
                <div className="profile-grid-item-title"> Prénom(s)</div>
                <div className="profile-grid-item-wraper">
                  <div className="profile-grid-item-icon">
                    <span className="pi pi-user"></span>
                  </div>
                  <div className="profile-grid-item-content">
                    {auth?.user?.firstname}
                  </div>
                </div>
              </div>
              <div className="profile-grid-item">
                <div className="profile-grid-item-title"> Rôle(s)</div>
                <div className="profile-grid-item-wraper">
                  <div className="profile-grid-item-icon">
                    <i className="pi pi-shield"></i>
                  </div>
                  <div className="profile-grid-item-content flex gap-1">
                    {auth?.roles &&
                      auth?.roles?.map((rol, index) => (
                        <div className="flex gap-1" key={index}>
                          <Tag value={rol}></Tag>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="profile-grid-item">
                <div className="profile-grid-item-title"> Email</div>
                <div className="profile-grid-item-wraper">
                  <div className="profile-grid-item-icon">
                    <i className="pi pi-envelope"></i>
                  </div>
                  <div className="profile-grid-item-content">
                    {auth?.user?.email}
                  </div>
                </div>
              </div>
              <div className="profile-grid-item">
                <div className="profile-grid-item-title"> Téléphone</div>
                <div className="profile-grid-item-wraper">
                  <div className="profile-grid-item-icon">
                    <i className="pi pi-mobile"></i>
                  </div>
                  <div className="profile-grid-item-content">
                    {auth?.user?.phone ?? "N/A"}
                  </div>
                </div>
              </div>
              <div className="profile-grid-item">
                <div className="profile-grid-item-title"> Anniversaire</div>
                <div className="profile-grid-item-wraper">
                  <div className="profile-grid-item-icon">
                    <i className="pi pi-gift"></i>
                  </div>
                  <div className="profile-grid-item-content">
                    {auth?.user?.birthday
                      ? moment(auth?.user?.birthday).format("DD-MM-YYYY")
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="profile-address-container">
            <div className="profile-address">
              <div className="profile-grid-item">
                <div className="profile-grid-item-title"> Adresse</div>
                <div className="profile-grid-item-wraper">
                  <div className="profile-grid-item-icon">
                    <i className="pi pi-address-book"></i>
                  </div>
                  <div className="profile-grid-item-content">
                    {auth?.user?.address ?? "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profil;
